<template>
  <Content>
    
      <div class="md-card-graph-total loading-total" v-if="isLoading">
        <Spinner
          name="line-scale-pulse-out-rapid"
          color="#448aff"
          no-fade-in/>
        </Spinner>
      </div>

      <md-table v-if="!isLoading" v-model="getSped.data" md-card @md-selected="onSelect" class="md-card-sped">
        <md-table-toolbar>
          <label class="title-card-requests">Arquivos Fiscais - Sped</label>
        </md-table-toolbar>

        <div
          v-if="getSped.total === 0"
          class="sem-total">
          <div class="title-total">
            <label class="title-card">Nenhum arquivo Sped localizado</label>
          </div>
        </div>
        
        <md-table-toolbar slot="md-table-alternate-header" slot-scope="{ count }">
          <div class="md-toolbar-section-start">{{ getAlternateLabel(count) }}</div>

          <div class="md-toolbar-section-end">
            <md-button class="md-icon-button" @click="donwloadSped()">
              <md-icon>cloud_download</md-icon>
            </md-button>
          </div>
        </md-table-toolbar>

        <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select>
          <md-table-cell md-label="Data Inicial">{{ formatDate(item.dateIni) }}</md-table-cell>
          <md-table-cell md-label="Data Final">{{ formatDate(item.dateEnd) }}</md-table-cell>
          <md-table-cell md-label="Arquivo" v-if="item.spedType === ICMSIPI"><label class="label-green">ICMS-IPI</label></md-table-cell>          
          <md-table-cell md-label="Arquivo" v-else-if="item.spedType === PISCOFINS"><label class="label-red">PIS-COFINS</label></md-table-cell>
        </md-table-row>
      </md-table>

      <Pagination
        v-if="!isLoading && getSped.total > 0"
        :total="getSped.total"
        :current_page="getPage"
        :itens-per-page="getSped.count"
        :offset="offset"
        :itens-page="getMaxSpedResults"
        @next="onChangePage"/>

  </Content>
</template>
<script>
import moment from 'moment';
import { http } from '../../public/api/backend';
import { ICMSIPI, PISCOFINS } from '../../public/api/spedType';
import Content from '../public/Content.vue';
import Pagination from '../../public/pagination/Pagination.vue';


export default {
  name: 'Speds',
  components: {
    Content,
    moment,
    Pagination,
  },
  data() {
    return {
      selected: [],
      offset: 3,
      client: [],
    };
  },
  computed: {
    getSped() {
      return this.$store.getters.getSped
    },
    getPage() {
      return this.$store.getters.getPage
    },
    getMaxSpedResults() {
      return this.$store.getters.getMaxSpedResults
    },
    isLoading() {
      return this.$store.getters.isLoading
    },
    ICMSIPI() {
      return ICMSIPI
    },    
    PISCOFINS() {
      return PISCOFINS
    }
  },  
  mounted() {
    this.$store.commit('SET_LOADING_STATUS', true)
    this.$store.dispatch('fetchSped')
  },
  methods: {

    onSelect (items) {
      this.selected = items
    },
      
    getAlternateLabel (count) {
      let plural = ''

      if (count > 1) {
        plural = 's'
      }

      return `${count} Arquivo${plural} selecionado${plural}`
    },

    onChangePage(page) {
      this.selected = []
      this.$store.commit('SET_PAGE', page)
      this.$store.dispatch('fetchSped')
    },

    donwloadSped() {
     
       swal({
          title: 'Deseja realizar o download?',
          text: 'Aguarde, pois o download será feito automaticamente!',
          icon: 'warning',
          buttons: {
            cancel: {
              text: 'Cancelar',
              value: 'cancel',
              visible: true,
              closeModal: true,
            },
            confirm: {
              text: 'OK',
              visible: true,
              closeModal: false
            }
          },
          dangerMode: false,
          closeModal: false,
          closeOnClickOutside: false,
        })
          .then((value) => {
            if (value === 'cancel') {
              swal.close()
              swal.stopLoading()
              return
            }

            for (let i = 0; i < this.selected.length; i++) {

              const link = document.createElement('a')
              link.href =  this.selected[i].spedFile
              link.setAttribute('target','_blank')
              link.click()
            }

            swal.stopLoading()
            swal.close()

          });
    },

    formatDate(value) {
      return moment(String(value)).format('DD/MM/YYYY')
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/client/sped/Speds.vue